import React, { FC, ReactElement } from 'react';

const layoutStyle = {
  width: '100%',
  display: 'flex',
  flexFlow: 'column wrap',
  justifyContent: 'flex-start',
  fontFamily: `'Roboto', sans-serif`,
  // Keep left/right gutter; remove top/bottom padding for tighter vertical fit.
  padding: '0 4px',
};

interface AgentPluginProps {
  children: ReactElement | ReactElement[];
}

const AgentPluginLayout: FC<AgentPluginProps> = (
  agentPluginProps: AgentPluginProps
) => {
  const { children } = agentPluginProps;
  const keyName = `Glance_${Math.floor(Math.random() * 1000)}`;

  return (
    <div key={keyName} style={layoutStyle}>
      <link rel="preconnect" href="https://fonts.googleapis.com"></link>
      <link rel="preconnect" href="https://fonts.gstatic.com"></link>
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap"
        rel="stylesheet"
      ></link>
      {React.Children.map(children, (child) => child)}
    </div>
  );
};

export default AgentPluginLayout;
